<!-- layout.component.html -->
<div class="flex flex-col h-screen">
  <app-header></app-header>

  <div class="flex flex-grow overflow-x-visible overflow-y-hidden bg-background dark:bg-dark-background">
    <app-sidebar [isSlimMode]="slimMode" (isSlimModeChange)="onSlimModeChange($event)" *ngIf="!hideSidebar"></app-sidebar>
    <div *ngIf="!hideSubSideBar">
      <ng-content select="[side-area]"></ng-content>
    </div>

    <div class="flex-grow overflow-hidden bg-background dark:bg-dark-background" [ngClass]="{
        'border-l border-gray-600 dark:border-gray-800': !hideSubSideBar
      }">
      <ng-content select="[body-area]"></ng-content>
    </div>
  </div>

  <app-footer></app-footer>
</div>
